export default "__VITE_ASSET__Kzb5XURE__ 640w, __VITE_ASSET__C2IqjzQ2__ 1024w, __VITE_ASSET__MpsYjWC2__ 1280w";